'use strict';

var propertyToValueAliases = require('./data/mappings.js');

var matchPropertyValue = function matchPropertyValue(property, value) {
  var aliasToValue = propertyToValueAliases.get(property);

  if (!aliasToValue) {
    throw new Error("Unknown property `".concat(property, "`."));
  }

  var canonicalValue = aliasToValue.get(value);

  if (canonicalValue) {
    return canonicalValue;
  }

  throw new Error("Unknown value `".concat(value, "` for property `").concat(property, "`."));
};

module.exports = matchPropertyValue;